import { Icon } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import LoadingIcon from "../../components/LoadingIcon";
import { ALERT } from "../../services/ResourceRelationsService";
import { ErrorMessagesIconTooltip } from "../Relations/ErrorMessagesIconTooltip";
import { IAuthorizationRelationData } from "./AuthorizationDomainModel";

export function RenderAlert(props: { row: IAuthorizationRelationData }) {
	const row = props.row;
	const { t } = useTranslation();

	if (row.errorMessages && row.errorMessages.length > 0) {
		return <ErrorMessagesIconTooltip errorMessages={row.errorMessages} />;
	}

	if (!row.employee)
		return null;

	if (row.alert == ALERT.Loading)
		return <LoadingIcon />;

	if (row.alert == ALERT.Error)
		return null;

	else if (row.alert == ALERT.Access) {
		if (row.resource) {
			let levelName = "";
			if (row.level)
				levelName = row.level.name;
			return <Icon
				title={t("control.relation.authorizationExist", { label: row.resource.label, levelName})}
				className="text-warning"
			>
				info
			</Icon>;
		}
		return <Icon
			title={t("control.relation.authorizationExistWithoutLevel", { label: row.resource.label})}
			className="text-warning"
		>
			info
		</Icon>;
	}
	else if (row.alert == ALERT.NoAccess) {
		return <Icon title={t("control.relation.newAuthorization")} className="text-success" >check_circle</Icon>;
	}

	return null;
}